import { useStyletron } from "baseui";
import { ListItem, ListItemLabel } from "baseui/list";
import { VscCalendar } from "react-icons/vsc";
import { ICalendar } from "../../../Calendar";
import { IScheduler } from "../../types";
import { HierarchyObjectNavigation } from "../../../../../components/HierarchyNavigation";
import { LoadingView } from "../../../../../components";
import { useGetAssignableCalendarsQuery } from "../../../../../services/schedulers";
import { SpecialEventVm } from "../../../../../services/schedulers/types";


const CalendarsList = (props: { app: IScheduler, selected: any, calendarsFilter(calendar: ICalendar): boolean, onItemSelected: (item: any) => void }) => {
    const [css] = useStyletron();
    const { data, error, isLoading, isSuccess } = useGetAssignableCalendarsQuery({ objectId: props.app.id, resourceGroupId: props.app.resourceGroupId })

    const selectableCalendars = data?.filter(props.calendarsFilter);

    function onSelect(item: any) { props.onItemSelected(item) }

    return (
        <>
            <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
                <ul
                    className={css({
                        width: '375px',
                        paddingLeft: 0,
                        paddingRight: 0,
                    })}
                >
                    {selectableCalendars?.map((item: ICalendar, index: number) => {
                        const overrides = item === props.selected ? {
                            Root: {
                                style: ({ $theme }) => ({
                                    backgroundColor: $theme.colors.accent100
                                })
                            }
                        } : {}

                        return (
                            <div onClick={() => onSelect(item)}>
                                <ListItem
                                    shape="ROUND"
                                    overrides={overrides}
                                    artwork={VscCalendar}
                                >
                                    <ListItemLabel
                                        overrides={{
                                            LabelContent: {
                                                style: ({ $theme }) => ({
                                                    fontSize: $theme.typography.ParagraphSmall.fontSize
                                                })
                                            }
                                        }} description={item.description}>
                                        <HierarchyObjectNavigation current={item.name} currentAsLink currentDescription={item.description} showDescription objectId={item.id} resourceGroupId={item.resourceGroupId} ></HierarchyObjectNavigation>
                                    </ListItemLabel>
                                </ListItem>
                            </div>)
                    }
                    )}
                </ul>
            </LoadingView>
        </>
    )
}

export default CalendarsList;




